import Service, {parseParams} from 'api';

export const list = (params = {}, config) => {
  const parsedParams = parseParams({
    sort: 'order DESC,name',
    limit: 0,
    ...params,
  });

  return Service.get(`qualifications?${parsedParams}`, config);
};

export const post = (data = {}, config = {}) => Service.post('qualifications', data, config);
export const put = (id, data = {}, config = {}) => Service.put(`qualifications/${id}`, data, config);
export const destroy = (id, config) => Service.delete(`qualifications/${id}`, config);
